<template>
  <div class="BaseSingleSelect">
    <div class="title">{{title}}</div>
    <div
      class="select-ul"
      :class="{oneRow:hide}"
    >
      <div
        class="select-li"
        :class="{checked:checked==='全部'}"
        @click="chooseAll"
      >全部
      </div>
      <div
        class="select-li"
        v-for="(opt,i) in opts"
        :key="i"
        :class="{checked:checked.includes(opt.value)}"
        @click="choose(opt.value)"
      >{{opt.name}}
      </div>
      <slot />
    </div>
    <div
      class="expand_text"
      v-if="showExpand"
      @click="changeHide"
    >
      更多筛选
      <i
        v-if="hide"
        class="el-icon-arrow-down"
      ></i>
      <i
        v-else
        class="el-icon-arrow-up"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  props: { title: String, checked: String, opts: Array, openExpand: Boolean },
  data () {
    return {
      hide: false
    }
  },
  computed: {
    showExpand () {
      return this.openExpand && this.opts.length > 10
    }
  },
  methods: {
    chooseAll () {
      this.$emit('update:checked', '全部')
    },
    choose (value) {
      const checkedList = this.checked.split(',')
      const valueIndex = checkedList.indexOf(value)
      if (valueIndex !== -1) {
        if ((checkedList.length - 1) === 0) {
          // 都没选中，则选中全部
          this.chooseAll()
        } else {
          // 已选中，则取消选中
          checkedList.splice(valueIndex, 1)
          this.$emit('update:checked', checkedList.join(','))
        }
      } else {
        // 未选中，则添加
        const checkAllIndex = checkedList.indexOf('全部')
        if (checkAllIndex !== -1) {
          checkedList.splice(checkAllIndex, 1)
        }
        checkedList.push(value)
        this.$emit('update:checked', checkedList.join(','))
      }
    },
    changeHide () {
      this.hide = !this.hide
    }
  }
}
</script>

<style lang="scss" scoped>
.BaseSingleSelect {
  display: flex;
  flex-wrap: wrap;
  .title {
    line-height: 31px;
    margin-right: 30px;
    color: #999;
  }
  .select-ul {
    flex: 1;
    width: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &.oneRow {
      height: 65px;
      overflow: hidden;
    }
    .select-li {
      margin-bottom: 24px;
      margin-right: 24px;
      padding: 6px 12px;
      text-align: center;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      &.checked {
        color: #fff;
        background-color: #347eee;
        border-radius: 10px;
      }
    }
  }
  .expand_text {
    height: 31px;
    line-height: 31px;
    cursor: pointer;
    color: #347eee;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/CaliberLibrary/CaliberLibraryTypeSelect.vue